var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as React from "react";
import styled from "styled-components";
import { bonfireGet } from "../../theme";
import { classnames } from "../../utils";
import { body } from "../../typography";
import { useMutationObserver } from "../../internal-hooks/useMutationObserver";
import { useOutsideClick } from "../../internal-hooks/useOutsideClick";
import { useOutsideFocus } from "../../internal-hooks/useOutsideFocus";
import { Tag } from "../Tag";
import { Text } from "../Text";
import { Button } from "../Button";
import { CloseIcon } from "../Icons/CloseIcon";
import { ChevronDownIcon } from "../Icons/ChevronDownIcon";
import TabbedMultiSelectCheckbox from "./TabbedMultiSelectCheckbox";
import TabbedMultiSelectDropdown from "./TabbedMultiSelectDropdown";
import { ViewIcon } from "../Icons/ViewIcon";
function isStaticSource(value) {
    return "items" in value;
}
function isAsyncSource(value) {
    return "fetchItems" in value;
}
function addUniqueItems(items, itemsToAdd) {
    var e_1, _a;
    var result = __spreadArray([], __read(items), false);
    var _loop_1 = function (newItem) {
        var value = newItem.value;
        if (result.find(function (x) { return x.value === value; })) {
            return "continue";
        }
        result.push(newItem);
    };
    try {
        for (var itemsToAdd_1 = __values(itemsToAdd), itemsToAdd_1_1 = itemsToAdd_1.next(); !itemsToAdd_1_1.done; itemsToAdd_1_1 = itemsToAdd_1.next()) {
            var newItem = itemsToAdd_1_1.value;
            _loop_1(newItem);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (itemsToAdd_1_1 && !itemsToAdd_1_1.done && (_a = itemsToAdd_1.return)) _a.call(itemsToAdd_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
}
function caseInsensitiveContains(value, searchText) {
    searchText = searchText.toLowerCase();
    return value.toLowerCase().indexOf(searchText) !== -1;
}
var TabbedMultiSelectStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .bn-tabbedmultiselect-search {\n    margin-top: 5px;\n    box-sizing: border-box;\n    border: 1px solid ", ";\n    border-radius: 4px;\n    background-color: ", ";\n    padding: 6px 11px 6px 15px;\n    display: flex;\n    flex-wrap: wrap;\n    &-tag {\n      cursor: pointer;\n      margin: 2px;\n    }\n    &-textField {\n      flex: 1;\n      display: flex;\n      &-input {\n        ", ";\n        width: 100%;\n        background: transparent;\n        border: none;\n        color: ", ";\n        &:focus {\n          outline: none;\n        }\n        &:placeholder-shown {\n          color: ", ";\n        }\n      }\n      &-icon {\n        align-self: center;\n        justify-self: flex-end;\n        cursor: pointer;\n      }\n    }\n    &-selectedtag {\n      cursor: pointer;\n    }\n    &-viewicon {\n      margin-right: 6px;\n    }\n  }\n  .bn-tag-label {\n    display: flex;\n  }\n"], ["\n  .bn-tabbedmultiselect-search {\n    margin-top: 5px;\n    box-sizing: border-box;\n    border: 1px solid ", ";\n    border-radius: 4px;\n    background-color: ", ";\n    padding: 6px 11px 6px 15px;\n    display: flex;\n    flex-wrap: wrap;\n    &-tag {\n      cursor: pointer;\n      margin: 2px;\n    }\n    &-textField {\n      flex: 1;\n      display: flex;\n      &-input {\n        ", ";\n        width: 100%;\n        background: transparent;\n        border: none;\n        color: ", ";\n        &:focus {\n          outline: none;\n        }\n        &:placeholder-shown {\n          color: ", ";\n        }\n      }\n      &-icon {\n        align-self: center;\n        justify-self: flex-end;\n        cursor: pointer;\n      }\n    }\n    &-selectedtag {\n      cursor: pointer;\n    }\n    &-viewicon {\n      margin-right: 6px;\n    }\n  }\n  .bn-tag-label {\n    display: flex;\n  }\n"])), bonfireGet("colors", "surface"), bonfireGet("colors", "backgroundLight"), body, bonfireGet("colors", "surfaceDark"), bonfireGet("colors", "surface"));
var TabbedMultiSelect = function (_a) {
    var id = _a.id, className = _a.className, style = _a.style, sources = _a.sources, selectedItems = _a.selectedItems, _b = _a.allowNewItem, allowNewItem = _b === void 0 ? "if-empty" : _b, onSelectedItemsChanged = _a.onSelectedItemsChanged, renderItemLabel = _a.renderItemLabel, _c = _a.groupSelectedItems, groupSelectedItems = _c === void 0 ? false : _c, _d = _a.hideSourceIfSingle, hideSourceIfSingle = _d === void 0 ? false : _d, _e = _a.showSelectAll, showSelectAll = _e === void 0 ? false : _e, _f = _a.selectAllAndResetByTab
    // This prop is used to add icons next to the label, this functionality isn't implemented yet.
    // renderItemRightContent
    , selectAllAndResetByTab = _f === void 0 ? false : _f
    // This prop is used to add icons next to the label, this functionality isn't implemented yet.
    // renderItemRightContent
    ;
    if (sources.length === 0) {
        throw new Error("[TabbedMultiSelect]: At least one item source is required.");
    }
    var content;
    var widgetRef = React.useRef(null);
    var inputRef = React.useRef(null);
    var dropDownRef = React.useRef(null);
    var _g = __read(React.useState(sources[0] != null ? sources[0].key : null), 2), selectedSourceKey = _g[0], setSelectedSourceKey = _g[1];
    var _h = __read(React.useState(0), 2), retryCounter = _h[0], setRetryCounter = _h[1];
    var _j = __read(React.useState(false), 2), isShowingSelected = _j[0], setShowingSelected = _j[1];
    var _k = __read(React.useState(""), 2), searchText = _k[0], setSearchText = _k[1];
    var _l = __read(React.useState(null), 2), currentSourceItems = _l[0], setCurrentSourceItems = _l[1];
    var _m = __read(React.useState(false), 2), currentSourceError = _m[0], setCurrentSourceError = _m[1];
    var _o = __read(React.useState(false), 2), isOpen = _o[0], setIsOpen = _o[1];
    var _p = __read(React.useState(0), 2), selfWidth = _p[0], setSelfWidth = _p[1];
    var selectedSource = sources.find(function (_a) {
        var key = _a.key;
        return key === selectedSourceKey;
    });
    if (selectedSourceKey == null || !selectedSource) {
        throw new Error("[TabbedMultiSelect]: No item source available.");
    }
    var hideSources = hideSourceIfSingle && sources.length === 1;
    // Note: This needs to run if selectedSource changes.  Which it will do every render
    // if the sources property is not memoized.
    React.useEffect(function () {
        if (isShowingSelected) {
            return;
        }
        var source = selectedSource;
        var sourceKey = selectedSourceKey;
        if (isStaticSource(source)) {
            // Set the state immediately without allowing a null value to pass.
            // This ensures that we do not flicker on the loading indicator during rerenders,
            // particularly when items are selected.
            setCurrentSourceItems(source.items
                .filter(function (item) { return caseInsensitiveContains(item.label, searchText); })
                .map(function (item) { return (__assign(__assign({}, item), { sourceKey: sourceKey })); }));
        }
        else if (isAsyncSource(source)) {
            setCurrentSourceItems(null);
            source
                .fetchItems({ searchText: searchText })
                .then(function (items) { return items.map(function (item) { return (__assign(__assign({}, item), { sourceKey: sourceKey })); }); })
                .then(setCurrentSourceItems)
                .catch(function (e) {
                console.error(e);
                setCurrentSourceError(true);
            });
        }
        else {
            throw new Error("[TabbedMultiSelect]: Unknown source type for ".concat(sourceKey));
        }
    }, [
        retryCounter,
        isShowingSelected,
        selectedSourceKey,
        searchText,
        selectedSource
    ]);
    React.useLayoutEffect(function () {
        var _a, _b, _c;
        setSelfWidth((_c = (_b = (_a = widgetRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0);
    }, [widgetRef.current]);
    useMutationObserver(widgetRef.current, function () {
        var _a, _b, _c;
        setSelfWidth((_c = (_b = (_a = widgetRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0);
    });
    var isItemSelected = React.useCallback(function (item) {
        return (selectedItems.find(function (_a) {
            var sourceKey = _a.sourceKey, value = _a.value;
            return item.sourceKey === sourceKey && item.value === value;
        }) != null);
    }, [selectedItems]);
    var onClick = React.useCallback(function (e) {
        var _a;
        e.preventDefault();
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [inputRef]);
    var onFocus = React.useCallback(function () {
        setIsOpen(true);
    }, []);
    var onSearchTextChange = React.useCallback(function (e) {
        setIsOpen(true);
        setSearchText(e.target.value);
    }, []);
    var onRemoveOne = React.useCallback(function (item) {
        onSelectedItemsChanged(selectedItems.filter(function (_a) {
            var sourceKey = _a.sourceKey, value = _a.value;
            return sourceKey !== item.sourceKey || value !== item.value;
        }));
        if (selectedItems.length === 1) {
            setShowingSelected(false);
        }
    }, [selectedItems]);
    var onRemoveAll = React.useCallback(function () {
        var _a;
        setShowingSelected(false);
        var incomingSelectedItems = [];
        if (selectAllAndResetByTab) {
            incomingSelectedItems = selectedItems.filter(function (selectedItem) { return selectedItem.sourceKey !== selectedSourceKey; });
        }
        onSelectedItemsChanged(incomingSelectedItems);
        setSearchText("");
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [inputRef, currentSourceItems, selectedItems]);
    var onKeyPress = React.useCallback(function (e) {
        var _a;
        if (e.keyCode === 27) {
            setIsOpen(false);
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    }, [inputRef]);
    var onShowSelectedToggle = React.useCallback(function () {
        setShowingSelected(function (value) { return !value; });
        setSearchText("");
    }, []);
    var onRetry = React.useCallback(function () {
        setRetryCounter(function (value) { return value + 1; });
    }, []);
    var onItemInclusionChanged = React.useCallback(function (item, included) {
        if (!included) {
            onSelectedItemsChanged(selectedItems.filter(function (_a) {
                var sourceKey = _a.sourceKey, value = _a.value;
                return sourceKey !== item.sourceKey || value !== item.value;
            }));
            if (selectedItems.length === 1) {
                onRemoveAll();
            }
        }
        else {
            onSelectedItemsChanged(__spreadArray(__spreadArray([], __read(selectedItems), false), [item], false));
            setSearchText("");
        }
    }, [selectedItems, onSelectedItemsChanged]);
    var onClose = React.useCallback(function () {
        setIsOpen(false);
    }, []);
    // When Select All is clicked while showing already selected elements, we do not want to duplicate those elements
    var onSelectAll = React.useCallback(function () {
        // we need to persist selections in other tabs when selecting all in another tab
        var incomingSelectedItems = selectedItems.filter(function (selectedItem) { return selectedItem.sourceKey !== selectedSourceKey; });
        var filteredItems = [];
        if (currentSourceItems) {
            incomingSelectedItems = incomingSelectedItems.filter(function (selectedItem) {
                !currentSourceItems.find(function (sourceItem) { return sourceItem.value === selectedItem.value; });
            });
            if (selectAllAndResetByTab) {
                filteredItems = __spreadArray([], __read(selectedItems.filter(function (item) { return item.sourceKey !== selectedSourceKey; })), false);
            }
        }
        if (selectAllAndResetByTab) {
            onSelectedItemsChanged(__spreadArray(__spreadArray(__spreadArray([], __read(currentSourceItems), false), __read(incomingSelectedItems), false), __read(filteredItems), false));
        }
        else {
            onSelectedItemsChanged(__spreadArray(__spreadArray([], __read(currentSourceItems), false), __read(incomingSelectedItems), false));
        }
    }, [currentSourceItems, selectedItems]);
    // Close the dropdown if the user goes somewhere else.
    useOutsideClick([widgetRef, dropDownRef], onClose, isOpen);
    useOutsideFocus([widgetRef, dropDownRef], onClose, isOpen);
    React.useEffect(function () {
        document.addEventListener("keydown", onKeyPress, false);
        return function () {
            document.removeEventListener("keydown", onKeyPress, false);
        };
    }, [onKeyPress]);
    var displayLoading = !isShowingSelected && !currentSourceError && currentSourceItems == null;
    var displayError = !isShowingSelected && currentSourceError;
    if (displayLoading) {
        content = React.createElement(Text, null, "Loading");
    }
    else if (displayError) {
        content = (React.createElement(Text, null,
            "An error occurred while loading the items.",
            " ",
            React.createElement(Button, { variant: "link", onClick: onRetry }, "Retry")));
    }
    else {
        var displayItems = void 0;
        var filteredSelectedItems = selectedItems.filter(function (item) {
            return caseInsensitiveContains(item.label, searchText);
        });
        if (isShowingSelected) {
            displayItems = filteredSelectedItems;
        }
        else {
            displayItems = __spreadArray([], __read(currentSourceItems), false);
            displayItems = addUniqueItems(displayItems, filteredSelectedItems.filter(function (x) { return x.sourceKey === selectedSourceKey; }));
            if (selectedSource.createNewItemFromSearch &&
                searchText.length > 0 &&
                (allowNewItem === "always" ||
                    (allowNewItem === "if-empty" && displayItems.length === 0))) {
                var item = selectedSource.createNewItemFromSearch(searchText);
                if (item) {
                    displayItems = addUniqueItems(displayItems, [
                        __assign(__assign({}, item), { sourceKey: selectedSourceKey })
                    ]);
                }
            }
        }
        if (displayItems.length === 0 && searchText) {
            content = (React.createElement("div", { className: "bn-tabbedmultiselect-dropdown-noresult" }, "Search has no results"));
        }
        else {
            content = (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "bn-tabbedmultiselect-dropdown-list" }, displayItems.map(function (item) {
                    return (React.createElement("div", { key: "".concat(item.value, "::").concat(item.sourceKey), className: "bn-tabbedmultiselect-dropdown-list-item", title: item.label, "aria-selected": isItemSelected(item) },
                        React.createElement(TabbedMultiSelectCheckbox, { item: item, label: renderItemLabel ? renderItemLabel(item) : item.label, 
                            // This is used to add icons next to the label, this functionality isn't implemented yet.
                            // rightContent={
                            //   renderItemRightContent
                            //     ? renderItemRightContent(item)
                            //     : undefined
                            // }
                            included: isItemSelected(item), onItemInclusionChanged: onItemInclusionChanged })));
                })),
                showSelectAll && (React.createElement("div", { className: "bn-tabbedmultiselect-dropdown-footer" },
                    React.createElement(Button, { className: "bn-tabbedmultiselect-dropdown-select-all", variant: "link", onClick: onSelectAll }, "Select All"),
                    React.createElement(Button, { className: "bn-tabbedmultiselect-dropdown-reset", variant: "link", disabled: selectedItems.length === 0, onClick: onRemoveAll }, "Reset")))));
        }
    }
    return (React.createElement(TabbedMultiSelectStyled, { id: id, className: classnames("bn-tabbedmultiselect", className), style: style },
        React.createElement("div", { ref: widgetRef, onClick: onClick, className: "bn-tabbedmultiselect-search" },
            groupSelectedItems && selectedItems.length ? (React.createElement(Tag, { className: "bn-tabbedmultiselect-search-selectedtag", onClick: onShowSelectedToggle, backgroundColor: isShowingSelected ? "linkLight" : "surface" },
                React.createElement(ViewIcon, { iconColor: "textLight", size: "small", className: "bn-tabbedmultiselect-search-viewicon" }),
                " ",
                selectedItems.filter(function (item) { return !!item; })
                    .length,
                " ",
                "Selected")) : (selectedItems.map(function (item) { return (React.createElement(Tag, { key: "".concat(item.sourceKey, "::").concat(item.value), className: "bn-tabbedmultiselect-search-tag", backgroundColor: isShowingSelected ? "linkLight" : "surface", onClick: onShowSelectedToggle, onRequestRemove: function () { return onRemoveOne(item); } }, item.label)); })),
            React.createElement("div", { className: "bn-tabbedmultiselect-search-textField" },
                React.createElement("input", { ref: inputRef, className: "bn-tabbedmultiselect-search-textField-input", placeholder: "Search", value: searchText, onChange: onSearchTextChange, onFocus: onFocus }),
                selectedItems.length > 0 ? (React.createElement(CloseIcon, { size: "small", className: "bn-tabbedmultiselect-search-textField-icon", onClick: onRemoveAll })) : (React.createElement(ChevronDownIcon, { size: "small", className: "bn-tabbedmultiselect-search-textField-icon" })))),
        React.createElement(TabbedMultiSelectDropdown, { className: "bn-tabbedmultiselect-dropdown", anchorEl: widgetRef.current, isOpen: isOpen, width: Math.max(selfWidth, 100), ref: dropDownRef, sources: sources, selectedSourceKey: selectedSourceKey, setSelectedSourceKey: setSelectedSourceKey, selectedItems: selectedItems, hideSourceIfSingle: hideSources }, content)));
};
export default TabbedMultiSelect;
var templateObject_1;
//# sourceMappingURL=TabbedMultiSelect.js.map